import { adminIcon } from 'assets';
import { IconProps } from 'types/Others';

const AdminIcon = ({
  width = 24,
  height = 24
}: IconProps) => {
  return (
      <img
        src={adminIcon}
        alt=""
        width={width}
        height={height}
      />
  )
}

export default AdminIcon